class DesktopGalleryMobileCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.gallery');
    this.nav = this.querySelector('.slider-nav');
    this.nextBtn = this.querySelector('[name="next"]');
    this.prevBtn = this.querySelector('[name="prev"]');
    this.slides = this.querySelectorAll('.gallery-block');
    this.slideSpan = 0;
    this.slidesToScroll = 1;
    this.scrollPos = 0;
    this.rtl = document.dir === 'rtl';
    
    console.log('DesktopGalleryMobileCarousel initialized:', {
      slider: !!this.slider,
      nav: !!this.nav,
      nextBtn: !!this.nextBtn,
      prevBtn: !!this.prevBtn,
      slides: this.slides.length
    });
    
    if (this.slider && this.nav) {
      this.init();
    } else {
      console.warn('DesktopGalleryMobileCarousel: Missing required elements', {
        slider: !!this.slider,
        nav: !!this.nav
      });
    }
  }

  init() {
    this.calculateSlideSpan();
    this.setButtonStates();
    this.addListeners();
  }

  calculateSlideSpan() {
    if (this.slides.length === 0) return;
    
    const firstSlide = this.slides[0];
    const slideWidth = firstSlide.offsetWidth;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    
    this.slideSpan = slideWidth + gap;
  }

  setButtonStates() {
    if (!this.nextBtn || !this.prevBtn) return;
    
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const currentScroll = this.slider.scrollLeft;
    
    this.prevBtn.disabled = currentScroll <= 0;
    this.nextBtn.disabled = currentScroll >= maxScroll - 1; // -1 for rounding errors
  }

  addListeners() {
    if (this.nav) {
      this.nav.addEventListener('click', this.handleNavClick.bind(this));
    }
    
    if (this.slider) {
      this.slider.addEventListener('scroll', this.handleScroll.bind(this));
    }
    
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  removeListeners() {
    if (this.nav) {
      this.nav.removeEventListener('click', this.handleNavClick.bind(this));
    }
    
    if (this.slider) {
      this.slider.removeEventListener('scroll', this.handleScroll.bind(this));
    }
    
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  handleScroll() {
    this.setButtonStates();
  }

  handleNavClick(evt) {
    console.log('Button clicked:', evt.target.name);
    if (!evt.target.matches('.slider-nav__btn')) return;

    if ((evt.target.name === 'next' && !this.rtl) || (evt.target.name === 'prev' && this.rtl)) {
      this.scrollPos = this.slider.scrollLeft + (this.slidesToScroll * this.slideSpan);
    } else {
      this.scrollPos = this.slider.scrollLeft - (this.slidesToScroll * this.slideSpan);
    }

    console.log('Scrolling to:', this.scrollPos);
    this.slider.scrollTo({ left: this.scrollPos, behavior: 'smooth' });
  }

  handleResize() {
    this.calculateSlideSpan();
    this.setButtonStates();
  }

  disconnectedCallback() {
    this.removeListeners();
  }
}

customElements.define('desktop-gallery-mobile-carousel', DesktopGalleryMobileCarousel);
